import React from 'react';
import { LanguageContext } from '../context/LanguageContext.js';
import { logError } from '../utils/monitoring.js';

class GlobalErrorBoundary extends React.Component {
  static contextType = LanguageContext;

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    logError('react_error_boundary', error, { componentStack: info?.componentStack });
  }

  render() {
    const t = this.context?.t || ((key) => key);

    if (this.state.hasError) {
      return (
        <div className="mx-auto flex min-h-screen w-full max-w-3xl items-center justify-center px-4">
          <div className="rounded-xl border border-red-200 bg-white p-6 text-center shadow-sm">
            <h1 className="text-xl font-semibold text-gray-900">{t('globalErrorTitle')}</h1>
            <p className="mt-2 text-sm text-gray-600">{t('globalErrorDescription')}</p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default GlobalErrorBoundary;
